import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './Components/Header/Header';
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import About from './Pages/About';
import Service from './Pages/Service';
import Footer from './Components/Footer/Footer';
import Bulksmservice from './Pages/Bulksmservice';
import Websitedesigning from './Pages/Websitedesigning';
import Digitalmarketing from './Pages/Digitalmarketing';
import Whatsappservice from './Pages/Whatsappservice';


function App() {
  return (
   <>
      <BrowserRouter>
        <Header/>
         <Routes>
            <Route path='/' element={<Home/>}></Route>
            <Route path='/about' element={<About/>}></Route>
            <Route path='/service' element={<Service/>}></Route>
            <Route path='/contact' element={<Contact/>}></Route>
            <Route path='/bulksmservice' element={<Bulksmservice/>}></Route>
            <Route path='/websitedesigning' element={<Websitedesigning/>}></Route>
            <Route path='/digitalmarketing' element={<Digitalmarketing/>}></Route>
            <Route path='/whatsappservice' element={<Whatsappservice/>}></Route>
         </Routes>
         <br></br>
         <Footer/>
      </BrowserRouter>
   </>
  );
}

export default App;
